import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Loading } from '@ebsco-ui/ebsco-ui';

import { sharedMessages } from '@app/translations';

import { useNovelistSelect } from './useNovelistSelect';
import { NovelistProps } from './constants';

export const Novelist: FC<NovelistProps> = ({ isbn = '', config }) => {
  const { $t } = useIntl();
  const { isSelectLoading, isScriptLoaded } = useNovelistSelect({
    isbn,
    config,
  });

  const shouldRender = isScriptLoaded && Boolean(isbn);

  return shouldRender ? (
    <aside
      aria-label={$t({
        id: 'instanceDetails.novelist',
        defaultMessage: 'Catalog enrichment powered by NoveList',
      })}
      data-auto="novelist"
      data-novelist-novelistselect={isbn}
    >
      {isSelectLoading && (
        <div data-auto="novelist-spinner">
          <Loading loadingMessage={$t(sharedMessages.loadingMessage)} />
        </div>
      )}
    </aside>
  ) : null;
};
